import {Injectable} from '@angular/core';
import {AbstractRestService} from 'src/app/shared/types/AbstractRestService';
import {HttpService} from '../http.service';
import {Observable, of, shareReplay, switchMap} from 'rxjs';
import {SystemFeatureFlagConsts} from 'src/app/shared/consts/SystemFeatureFlags.consts';

@Injectable({
  providedIn: 'root'
})
export class GeneralSettingsService extends AbstractRestService<any, any> {
  protected baseEndpoint$: Observable<string> = of('generalSettings');

  systemFeatureFlagKeysValues$ = this.getSystemFeatureFlagValues(SystemFeatureFlagConsts.getAll).pipe(
    shareReplay(1)
  );

  constructor(
    protected http: HttpService,
  ) {
    super(http);
  }

  public getSystemFeatureFlagValues(featureFlagKeys: string[]): Observable<{ [id: string]: boolean; }> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<{ [id: string]: boolean; }>(`${baseUrl}/flags`, featureFlagKeys))
    );
  }

  public GetByKey(key: string): Observable<any> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<any>(`${baseUrl}/key/${key}/value`))
    );
  }

  public IsCovercyDomain(email: string) {
    return email.toLowerCase().endsWith('@covercy.com');
  }
}
